import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/auth/Login";
import Home from "./components/auth/Home";
import Ticket from "./components/Screen/Ticket/Ticket";
import Registration from "./components/Screen/Ticket/Registration";
import InviteReview from "./components/Screen/Ticket/InviteReview";
import Item from "./components/Screen/Item/List";
import ItemCreate from "./components/Screen/Item/Form";
import ItemShow from "./components/Screen/Item/Show";
import ConfigScreen from "./components/ui/ConfigScreen";
import Order from "./components/Screen/OrderManagement/Order";
import Password from "./components/auth/Password";
import OrderCreate from "./components/Screen/Order/Form";
import Order1 from "./components/Screen/Order/List";
import CustomerCreate from "./components/Screen/Customer/Form";
import Customer from "./components/Screen/Customer/List";
import CustomerShow from "./components/Screen/Customer/Show";
import MainDashboard from "./components/Dashboard/MainDashboard";
import SubDashboard from "./components/Dashboard/SubDashboard";
import "./resources/css/vyg.css";
import { jwtDecode } from "jwt-decode";
import { userLogOut } from "../src/components/utils/utils";
import './index.css'; 

function App() {
  useEffect(() => {
    const checkAuthentication = async () => {
      const token = localStorage.getItem("vyg_access_token");

      if (token) {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds

        if (decodedToken.exp && decodedToken.exp < currentTime) {
          const success = await refreshAccessToken(
            localStorage.getItem("vyg_refresh_token"),
          );
          if (!success) {
            handleLogout();
          }
        }
      }
    };

    checkAuthentication();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      refreshAccessToken(localStorage.getItem("vyg_refresh_token"));
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  const refreshAccessToken = async (refreshToken) => {
    if (!refreshToken) {
      return false;
    }

    try {
      const response = await fetch(process.env.REACT_APP_OAUTH_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          refresh_token: refreshToken,
          client_id: "eVyoog",
          client_secret: "ssFF0O7wX5UlmWECCxjfOmflw4WRSJng",
          grant_type: "refresh_token",
        }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("vyg_access_token", data.access_token);
        localStorage.setItem("vyg_refresh_token", data.refresh_token);
        return true;
      } else {
        console.error("Failed to refresh token");
        return false;
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
      return false;
    }
  };

  const handleLogout = () => {
    userLogOut();
  };

  const ProtectedRoute = ({ element }) => {
    const token = localStorage.getItem("vyg_access_token");
    if (token) {
      return element;
    } else {
      const redirectTo = window.location.pathname + window.location.search; // Capture path and query parameters
      return <Navigate to={`/?redirect=${encodeURIComponent(redirectTo)}`} />;
    }
  };

  return (
    <Router>
      <div>
        <Routes>
          {/* Redirect to Ticket page if authenticated */}
          <Route
            path="/"
            element={
              localStorage.getItem("vyg_access_token") ? (
                <Navigate to="/ticket" />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/ticket"
            element={
              localStorage.getItem("vyg_access_token") ? (
                <Ticket />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route path="/password" element={<Password />} />
          <Route path="/item" element={<Item />} />
          <Route path="/order" element={<Order />} />
          <Route path="/home" element={<Home />} />

          <Route
            path="/inviteReview"
            element={<ProtectedRoute element={<InviteReview />} />}
          />
          <Route path="/show" element={<ItemShow />} />
          <Route path="/screen-config" element={<ConfigScreen />} />
          <Route path="/register" element={<Registration />} />
          <Route path="/new-item" element={<ItemCreate />} />
          <Route path="/order1" element={<Order1 />} />
          <Route path="/new-order" element={<OrderCreate />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/new-customer" element={<CustomerCreate />} />
          <Route path="/show" element={<CustomerShow />} />
          <Route path="/main-dashboard" element={<MainDashboard />} />
          <Route path="/sub-dashboard" element={<SubDashboard />} />
          {/* <Route path="/ticket" element={isAuthenticated ? <Ticket /> : <Navigate to="/" />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
